/**
 * @file index.tsx
 *
 * @fileoverview Renders the default icon for when a job has no logo.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import BriefcaseIcon from '~/vcl/icons/Briefcase';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { Job } from '~/jobiqo/types/types';

interface JobTeaserNoLogoIconSlotProps {
  /**
   * The job to render the icon for.
   */
  job: Slottable<Job>;
}

export default function JobTeaserNoLogoIconSlot({
  job,
}: JobTeaserNoLogoIconSlotProps) {
  const intl = useIntl();
  const { JOBS } = useFrontendConfig();

  return (
    <div
      style={{ width: `${JOBS.JOB_TEASER.LOGO_WIDTH}px`, textAlign: 'center' }}
    >
      <BriefcaseIcon
        color="gray2"
        height="40"
        width="40"
        title={intl.formatMessage({
          id: 'job_teaser_logo_placeholder',
          defaultMessage: 'No logo available',
        })}
      />
    </div>
  );
}
export { JobTeaserNoLogoIconSlot };
